/* eslint-disable eqeqeq,no-nested-ternary,@typescript-eslint/no-redeclare,no-tabs,no-var */

xplenty.filter('formatTime', function () {
  return function (seconds) {
    const duration = moment.duration(seconds, 'seconds');

    var seconds = duration.seconds();
    const minutes = duration.minutes();
    const hours = duration.hours();
    const days = duration.days();
    const months = duration.months();
    const years = duration.years();
    let fmt = '';

    // if( seconds > 0 ) {
    // 	fmt = seconds + " sec" + fmt;
    // }
    // if( minutes > 0 ) {
    // 	fmt = minutes + " min " + fmt;
    // }
    // if( hours > 0 ) {
    // 	fmt = hours + " hrs " + fmt;
    // }
    // if( days > 0 ) {
    // 	fmt = days + " d " + fmt;
    // }
    // if( months > 0 ) {
    // 	fmt = months + " mo " + fmt;
    // }

    fmt = _.chain([hours, minutes, seconds])
      .reject(function (o, i) {
        return o == 0 && i == 0;
      }) // Do not take of minutes
      .map(function (o, i) {
        return i == 0 ? o : o < 10 ? `0${o}` : o;
      })
      .join(':')
      .value();

    if (days > 0) {
      fmt = `${days}d, ${fmt}`;
    }
    if (months > 0) {
      fmt = `${months}mo, ${fmt}`;
    }
    // Edge case :)
    if (years > 0) {
      fmt = `${years}y, ${fmt}`;
    }
    return fmt;
  };
});
